import { Button, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFederalTaxTable extends Layout {
    buttonVersion: Button;
    dataheaderFederalTaxTable: DataHeader;
    label2020AndAfter: Label;
    labelA: Label;
    labelH: Label;
    labelHeadOfHouseholdTaxTable: Label;
    labelHeadOfHouseholdTaxTableMultipleJobs: Label;
    labelMarriedTaxTable: Label;
    labelMarriedTaxTableMultipleJobs: Label;
    labelMedicarePosition: Label;
    labelPriorTo2020: Label;
    labelS: Label;
    labelSingleTaxTable: Label;
    labelSingleTaxTableMultipleJobs: Label;
    labelT: Label;
    layoutHeadOfHouseholdTaxTable: Layout;
    layoutHeadOfHouseholdTaxTableMultipleJobs: Layout;
    layoutMarriedTaxTable: Layout;
    layoutMarriedTaxTableMultipleJobs: Layout;
    layoutSingleTaxTable: Layout;
    layoutSingleTaxTableMultipleJobs: Layout;
    panel401kAccounts: Panel;
    panelAllowDeduct: Panel;
    panelCatchUpAccounts: Panel;
    panelCatchUpInfo: Panel;
    panelHeadOfHousehold: Panel;
    panelHeadOfHouseholdMultipleJobs: Panel;
    panelMarriedTaxTable: Panel;
    panelMarriedTaxTableMultipleJobs: Panel;
    panelMedFields: Panel;
    panelRothAccounts: Panel;
    panelRothCatchUpAccounts: Panel;
    panelSSFields: Panel;
    panelSingleTaxTable: Panel;
    panelSingleTaxTableMultipleJobs: Panel;
    panelWithholdingInfo: Panel;
    sourceFedtaxtable: DataSource;
    sourceHeadofhouseholdtaxtable: DataSource;
    sourceHeadofhouseholdtaxtablemultiplejobs: DataSource;
    sourceMarriedTaxTable: DataSource;
    sourceMarriedtaxtablemultiplejobs: DataSource;
    sourceSingletaxtable: DataSource;
    sourceSingletaxtablemultiplejobs: DataSource;
    switchCatchUpMethod: Switch;
    switchEnableCatchUp: Switch;
    switchEnableRoth: Switch;
    switchTaxTable: Switch;
    tab401kAccounts: Tab;
    tabAccounts: Tab;
    tabDeductions: Tab;
    tabGeneral: Tab;
    tabWithholdingTables: Tab;
    tabsetFederalTaxTable: Tabset;
    textboxAftrThrshMedPct: Textbox;
    textboxBonusTaxRate: Textbox;
    textboxCatchupLiabGlid: Textbox;
    textboxE401kLiabGlid: Textbox;
    textboxEmpFicaHiPct: Textbox;
    textboxEmpFicaSsPct: Textbox;
    textboxEmplrFedId: Textbox;
    textboxEmplrFicaHiPct: Textbox;
    textboxEmplrFicaSsPct: Textbox;
    textboxEmplrFutaPct: Textbox;
    textboxFedWhAllowance: Textbox;
    textboxFedWhGlid: Textbox;
    textboxFicaHiEliabGlid: Textbox;
    textboxFicaHiExpGlid: Textbox;
    textboxFicaHiRliabGlid: Textbox;
    textboxFicaSsEliabGlid: Textbox;
    textboxFicaSsExpGlid: Textbox;
    textboxFicaSsRliabGlid: Textbox;
    textboxFutaExpGlid: Textbox;
    textboxFutaLiabGlid: Textbox;
    textboxHigherCatchupBegAge: Textbox;
    textboxHigherCatchupEndAge: Textbox;
    textboxHigherCatchupLimit: Textbox;
    textboxM401kExpGlid: Textbox;
    textboxM401kLiabGlid: Textbox;
    textboxMCatchExpGlid: Textbox;
    textboxMCatchLiabGlid: Textbox;
    textboxMRothCExpGlid: Textbox;
    textboxMRothCLiabGlid: Textbox;
    textboxMRothExpGlid: Textbox;
    textboxMRothLiabGlid: Textbox;
    textboxMarriedDeductions: Textbox;
    textboxMax401kAmt: Textbox;
    textboxMaxCatchupAmt: Textbox;
    textboxMaxFicaHiAmt: Textbox;
    textboxMaxFicaSsAmt: Textbox;
    textboxMaxFutaAmt: Textbox;
    textboxMedWageThrshld: Textbox;
    textboxOtherwiseDeductOpt: Textbox;
    textboxOtherwiseDeductSingle: Textbox;
    textboxRothCLiabGlid: Textbox;
    textboxRothLiabGlid: Textbox;
}
